import React from 'react';
import { Outlet } from 'react-router-dom';

const SchoolGroupVacancies: React.FC = () => {
  return <Outlet />;
};

export default SchoolGroupVacancies;
